var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"color":"#ff5454"}},[_vm._v(_vm._s(_vm.time))])
}
var staticRenderFns = []

export { render, staticRenderFns }